import { aboutData } from '@/mocks/homeData';

export default function SectionAbout() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12">
          <div className="flex-1 w-full">
            <div className="relative rounded-lg overflow-hidden aspect-[4/3] bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20editorial%20office%20workspace%20with%20multiple%20screens%20displaying%20news%20feeds%2C%20soft%20golden%20ambient%20lighting%2C%20modern%20minimalist%20desk%20setup%2C%20cozy%20professional%20atmosphere%2C%20rich%20amber%20and%20warm%20cream%20tones%2C%20editorial%20newsroom%20aesthetic%2C%20soft%20bokeh%20background%2C%20no%20visible%20people%2C%20clean%20composition&width=800&height=600&seq=about-visual&orientation=landscape"
                alt="关于吃瓜爆料"
                className="w-full h-full object-cover object-top"
                loading="lazy"
              />
            </div>
          </div>
          <div className="flex-1 w-full">
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-4">
              {aboutData.title}
            </h2>
            <div className="w-12 h-1 bg-primary-500 rounded-full mb-5"></div>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
              {aboutData.content}
            </p>
            <div className="flex flex-wrap gap-3">
              <div className="px-4 py-2 bg-primary-50 rounded-md text-sm text-primary-700 font-medium">
                日均更新 500+ 条
              </div>
              <div className="px-4 py-2 bg-accent-50 rounded-md text-sm text-accent-700 font-medium">
                月活用户 1000万+
              </div>
              <div className="px-4 py-2 bg-secondary-50 rounded-md text-sm text-secondary-700 font-medium">
                收录爆料 50000+ 条
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}